export enum WidthTokenType {
  List = 'list-width',
}
